import * as React from 'react';

import PageIntro from '../../components/layout/PageIntro';
import PrimaryLayout from '../../layouts/PrimaryLayout';
import { createStyles, Typography, withStyles } from '@nelnet/unifi-components-react';
import PlatformCardGrid from '../../components/layout/PlatformCardGrid';

const styles = () =>
  createStyles({
    boldDivider: {
      paddingBottom: '2rem',
      borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
    },
  });

const WebComponents: React.FunctionComponent = () => {
  const title = 'Theming';
  const slug = '/theming/';

  return (
    <PrimaryLayout title={title} path={slug}>
      <PageIntro title={title} path={slug} />
      <div>
        <Typography variant="h2">Development Documentation</Typography>
        <Typography>
          Learn how to use the Unifi theme, and extend it to customize your application. Also review
          review additional theming options for customizing Unifi and extending Unifi theming to
          your own components.
        </Typography>
      </div>
      <PlatformCardGrid link="theming" />
    </PrimaryLayout>
  );
};

export default withStyles(styles)(WebComponents);
